import { Sun, Moon, Settings, FolderTree, MessageSquare, LayoutDashboard } from 'lucide-react';
import { Link } from 'react-router-dom';

interface StudioHeaderProps {
    isDark: boolean;
    toggleTheme: () => void;
    showExplorer: boolean;
    onToggleExplorer: () => void;
    showChat: boolean;
    onToggleChat: () => void;
}

export function StudioHeader({ isDark, toggleTheme, showExplorer, onToggleExplorer, showChat, onToggleChat }: StudioHeaderProps) {

    return (
        <header className="flex items-center justify-between px-4 py-2 border-b border-border bg-app-surface/80 backdrop-blur-md sticky top-0 z-10">
            <div className="flex items-center gap-3">
                <Link to="/mate" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
                    <svg width="32px" height="32px" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true" role="img"
                        className="iconify iconify--twemoji" preserveAspectRatio="xMidYMid meet">
                        <path fill="#662113"
                            d="M15.971 15.083c-1.458-2.333-.667-7.708 0-8.958s-.542-2.458-1.5-.458s-.996 3-3.162 2.458s-1.088-3.292-.379-5.625c.729-2.4-.917-1.959-1.667-.458c-.75 1.5-1.254 5.693-2.901 5.984c-1.647.291-6.099.599-2.851-5.651C4.818-.139 2.773-.656 1.68 1.459C.361 4.007-.404 7.25.221 8.625c1.113 2.448 3.483 2.95 6.983 2.284s6.101-.634 6.101 1.133c0 1.872.208 3.458 1.042 3.625s1.624-.584 1.624-.584zm4.057 0c1.458-2.333.667-7.708 0-8.958s.542-2.458 1.5-.458s.996 3 3.162 2.458s1.088-3.292.379-5.625c-.729-2.4.917-1.959 1.667-.458s1.254 5.693 2.901 5.984c1.647.292 6.099.599 2.851-5.651c-1.307-2.514.737-3.031 1.831-.916c1.318 2.549 2.084 5.792 1.459 7.167c-1.113 2.448-3.482 2.95-6.982 2.284s-6.102-.634-6.102 1.133c0 1.872-.208 3.458-1.041 3.625s-1.625-.585-1.625-.585z"></path>
                        <path fill="#C1694F"
                            d="M13.859 15.495c.596 2.392.16 4.422-2.231 5.017c-2.392.596-6.344.559-7.958-1.303c-2.294-2.646-2.531-6.391-1.189-6.725c1.34-.334 10.783.62 11.378 3.011zm8.283 0c-.596 2.392-.16 4.422 2.231 5.017c2.392.596 6.345.559 7.958-1.303c2.295-2.646 2.531-6.391 1.189-6.725c-1.34-.334-10.783.62-11.378 3.011z"></path>
                        <path fill="#272B2B"
                            d="M2.48 12.484c-.943.235-1.102 2.157-.317 4.198l3.374-4.134c-1.457-.146-2.643-.167-3.057-.064zm31.041 0c-.419-.104-1.632-.083-3.118.069l3.445 4.106c.774-2.032.613-3.941-.327-4.175z"></path>
                        <path fill="#E6AAAA"
                            d="M12.052 15.997c.871 1.393-.553 2.229-1.946 3.099c-1.394.871-4.608-.203-5.479-1.596c-.871-1.394-1.186-3.131-.676-3.45c.51-.318 7.23.553 8.101 1.947zm11.896 0c-.871 1.393.553 2.229 1.945 3.099c1.394.871 4.608-.203 5.479-1.596c.871-1.394 1.185-3.131.676-3.45c-.51-.318-7.229.553-8.1 1.947z"></path>
                        <path fill="#C1694F"
                            d="M18 14.125h-.002c-10.271.001-8.703 3.959-7.603 10.541c1.1 6.584 2.401 11.256 7.605 11.256c5.203 0 6.502-4.672 7.604-11.256c1.099-6.582 2.666-10.54-7.604-10.541z"></path>
                        <path fill="#272B2B"
                            d="M11.826 22.851s-.75-1.299.549-2.049s2.049.549 2.049.549l.75 1.299s.75 1.299-.549 2.049s-2.049-.549-2.049-.549l-.75-1.299zm9.75-1.5s.75-1.299 2.049-.549s.549 2.049.549 2.049l-.75 1.299s-.75 1.299-2.049.549s-.549-2.049-.549-2.049l.75-1.299zm-6.35 12.915c-.925-.188 1.85-3.596 2.774-3.596s3.699 3.407 2.774 3.596c-.924.188-4.624.188-5.548 0z"></path>
                    </svg>
                    <h1 className="text-lg font-bold tracking-tight">FormCms SchemaGen AI</h1>
                </Link>
            </div>

            <div className="flex items-center gap-4">
                <a
                    href="/admin"
                    className="p-2 hover:bg-app-muted rounded-full transition-colors border border-transparent hover:border-border text-primary-muted hover:text-primary"
                    title="Admin"
                >
                    <LayoutDashboard className="w-5 h-5" />
                </a>
                <button
                    onClick={onToggleExplorer}
                    className={`p-2 hover:bg-app-muted rounded-full transition-colors border border-transparent hover:border-border ${!showExplorer ? 'bg-app-muted border-border' : ''}`}
                    title={showExplorer ? "Hide Explorer" : "Show Explorer"}
                >
                    <FolderTree className="w-5 h-5 text-primary-muted hover:text-primary transition-colors" />
                </button>
                <button
                    onClick={onToggleChat}
                    className={`p-2 hover:bg-app-muted rounded-full transition-colors border border-transparent hover:border-border ${!showChat ? 'bg-app-muted border-border' : ''}`}
                    title={showChat ? "Hide Chat" : "Show Chat"}
                >
                    <MessageSquare className="w-5 h-5 text-primary-muted hover:text-primary transition-colors" />
                </button>
                <Link
                    to="/mate/settings"
                    className="p-2 hover:bg-app-muted rounded-full transition-colors border border-transparent hover:border-border text-primary-muted hover:text-primary"
                    title="System Settings"
                >
                    <Settings className="w-5 h-5" />
                </Link>
                <button
                    onClick={toggleTheme}
                    className="p-2 hover:bg-app-muted rounded-full transition-colors border border-border"
                >
                    {isDark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
                </button>

            </div>
        </header>
    );
}
